import styled from "styled-components";

export const VideoTileOverlayDefaultBox = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 1.5rem;
    ${({theme}) => theme.font.presets.regular};
    color: ${({theme}) => theme.colors.textLight};
    background: rgba(0,0,0,0.5);
`;
